import { Link } from 'react-router-dom';
import './Error404.css'

const Error404 = () => {
  return (
    <>
      <article className="page-404">
        <header>
          <h2 className="h2 article-title">Page 404</h2>
        </header>
        <section>
          <h2 className='h1'>Page Not Found</h2>
          <Link to={'/'}>Go Home</Link>
        </section>
      </article>
    </>
  )
}

export default Error404
